import { createAction, props } from '@ngrx/store';
import { PaymentMethodValid } from '@core/enums';
import { CardCheckout } from '@core/models/payment/payment-response';
import { IResponseBadRequest, IResponseObjectSuccess } from '@core/interfaces';
import { OrderForm, OrderResponse, PaymentResult } from '@core/models';
import { CheckoutPaymentFlow } from '@/features/checkout/domain/interfaces/checkout-payment.interface';
import { CheckoutPaymentPlanType } from '@/features/checkout/domain/enum/checkout-flow.enum';

export const CHECKOUT_UPDATE_LOADING = createAction('[Checkout] Update Loading', props<{ loading: boolean }>());

export const CHECKOUT_SET_CURRENT_STEP = createAction('[Checkout] Set Current Step', props<{ currentStep: number }>());

export const CHECKOUT_SET_PAYMENT_METHOD = createAction('[Checkout] Set Payment Method', props<{ paymentMethod: PaymentMethodValid }>());

export const CHECKOUT_UPDATE_CREDIT_CARD_FORM = createAction('[Checkout] Update Credit Card Form', props<{ formData: CardCheckout | null }>());

export const CHECKOUT_PLACE_ORDER = createAction(
  '[Checkout] Place Order',
  props<{ paymentPlan: CheckoutPaymentFlow }>()
);

export const CHECKOUT_CREATE_CASH_ORDER = createAction(
  '[Checkout] Create Cash Order',
  props<{ order: Extract<CheckoutPaymentFlow, { type: CheckoutPaymentPlanType.Cash }>['order'] }>()
);

export const CHECKOUT_CREATE_CARD_ORDER = createAction(
  '[Checkout] Create Card Order',
  props<{ paymentPlan: Extract<CheckoutPaymentFlow, { type: CheckoutPaymentPlanType.Card }> }>()
);

export const CHECKOUT_VALIDATE_ORDER = createAction('[Checkout] Validate Order');

export const CHECKOUT_PLACE_ORDER_SUCCESS = createAction(
  '[Checkout] Place Order Success',
  props<{ order: IResponseObjectSuccess<OrderResponse>; orderForm: OrderForm }>()
);

export const CHECKOUT_PLACE_ORDER_FAILURE = createAction(
  '[Checkout] Place Order Failure',
  props<{ error: IResponseBadRequest | PaymentResult | Error | null | string }>()
);

export const CHECKOUT_RESET_FORM = createAction('[Checkout] Reset Form');

export const CHECKOUT_CLEAR_STATE = createAction('[Checkout] Clear State');

export const CHECKOUT_VALIDATE_AVAILABILITY_PRODUCT_ORDER_SUCCESS = createAction('[Checkout] Validate Availability Product Order Success');

export const CHECKOUT_VALIDATE_AVAILABILITY_PRODUCT_ORDER_FAILURE = createAction('[Checkout] Validate Availability Product Order Failure');

export const CHECKOUT_PLACE_ORDER_SEND_EMAIL = createAction('[Checkout] Place Order Send Email', props<{ order: IResponseObjectSuccess<OrderResponse>; orderForm: OrderForm }>());